import {
  PROFILE_UPDATE_DISCLAIMER_VISIBILITY,
  SET_PROGRESS_BAR_ON_CLICK_ACTION,
  PROFILE_INIT_PAGES,
  PROFILE_UPDATE_PAGE,
  PROFILE_TOGGLE_SHOW_ALL_PAGE,
  PROFILE_NEXT_PAGE,
  PROFILE_LAST_PAGE,
  PROFILE_JUMP_TO_PAGE,
  PROFILE_SET_PAGE_VISITED,
} from '../actions/actionTypes';

const getProgressBarSteps = (state, fct) => {
  let barProps = [];
  for (var p in state.pages) {
    barProps.push({
      stepKey: p,
      stepLabel: state.pages[p].pageLabel,
      completed: state.pages[p].completed,
    });
  }
  return barProps;
};

const updatePage = state => {
  const newState = { ...state };
  const steps = getProgressBarSteps(newState);
  return {
    ...newState,
    progressBarProps: {
      ...newState.progressBarProps,
      showCompletedIcon: state.showCompletedIcon,
      currentStep: newState.currentPage,
      steps,
    },
  };
};

const updateProgressBarOnClickAction = (state, resp) => {
  var fct = resp.fct;
  var newState = { ...state };
  var newBarProps = getProgressBarSteps(newState, fct);

  return {
    ...newState,
    progressBarProps: {
      ...newState.progressBarProps,
      onClickAction: fct,
      steps: getProgressBarSteps(newState),
    },
  };
};

const updateWindowHash = hash => {
  hash.replace(/\W/g, '');
  window.location.hash = hash;
};

const defaultState = {
  currentPage: null,
};

export default function pageReducer(state = defaultState, resp) {
  let newState = {};
  const { type, value } = resp;

  switch (type) {
    case PROFILE_UPDATE_DISCLAIMER_VISIBILITY:
      newState = {
        ...state,
        showDisclaimer: value ? value.visibility : false,
      };
      break;
    case PROFILE_TOGGLE_SHOW_ALL_PAGE:
      newState = {
        ...state,
        showAllPage: value ? value.showAllPage : !state.showAllPage,
      };
    case PROFILE_INIT_PAGES:
      /* //we do this in updatePage already.
    let progressBarProps = {
      currentStep: newState.currentPage,
      showCompletedIcon: state.showCompletedIcon,
      steps: getProgressBarSteps(newState)
    };
    newState = {
      ...state,
      progressBarProps
    };*/
      break;

    case PROFILE_UPDATE_PAGE:
      newState = {
        ...state,
        currentPage: value.currentPage,
      };
      break;

    case PROFILE_NEXT_PAGE:
      const nextPage = state.pages[value.currentPage].nextPage;
      updateWindowHash(nextPage);
      newState = {
        ...state,
        currentPage: nextPage,
      };
      break;

    case PROFILE_LAST_PAGE:
      const lastPage = state.pages[value.currentPage].lastPage;
      updateWindowHash(lastPage);
      newState = {
        ...state,
        currentPage: lastPage,
      };
      break;

    case PROFILE_JUMP_TO_PAGE:
      window.history.pushState('', value.currentPage, window.location.pathname);
      updateWindowHash(value.currentPage);
      newState = {
        ...state,
        currentPage: value.currentPage,
        transitionType: value.transitionType,
      };
      break;

    case SET_PROGRESS_BAR_ON_CLICK_ACTION:
      return updateProgressBarOnClickAction({ ...state }, value.onClick);

    case PROFILE_SET_PAGE_VISITED:
      newState = {
        ...state,
        pages: {
          ...state.pages,
        },
      };
      if (value.pageName !== 'Finished') {
        newState.pages = {
          ...state.pages,
          [value.pageName]: {
            ...state.pages[value.pageName],
            visited: value.visited,
          },
        };
      }
      break;

    default:
      newState = state;
      break;
  }
  newState = updatePage(newState);
  return newState;
}
